import { BaseModel, StrictBaseModelPart, hasUnionKeys } from '@dev-stream/utils';

export class BillingBankCardVM extends BaseModel<BillingBankCardVM> {
    protected BASE_TYPE = BillingBankCardVM;
    'Id'!: string | null;
    'CardMask'!: string | null;
    'ExpirationMonthYear'!: string | null;
    'CardType'!: string | null;
    'Name'!: string | null;
    'GatewayName'!: string | null;
    'Issuer'!: string | null;
    'IsDefault'!: boolean | null;

    public GetDefaultValue(): StrictBaseModelPart<BillingBankCardVM> {
        return {
            Id: null,
            CardMask: null,
            ExpirationMonthYear: null,
            CardType: null,
            Name: null,
            GatewayName: null,
            Issuer: null,
            IsDefault: null,
        };
    }

    public static isBillingBankCardVM(o: any): o is BillingBankCardVM {
        return (
            o instanceof BillingBankCardVM ||
            hasUnionKeys(o, [
                'Id',
                'CardMask',
                'ExpirationMonthYear',
                'CardType',
                'Name',
                'GatewayName',
                'Issuer',
                'IsDefault',
            ])
        );
    }
}
